import { render, staticRenderFns } from "./detailAutoClaim.vue?vue&type=template&id=320f4194&scoped=true&"
import script from "./detailAutoClaim.vue?vue&type=script&lang=js&"
export * from "./detailAutoClaim.vue?vue&type=script&lang=js&"
import style0 from "./detailAutoClaim.vue?vue&type=style&index=0&id=320f4194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320f4194",
  null
  
)

export default component.exports